'use client'

import { useState } from 'react'
import { Button, Text } from '@vinted/web-ui'

import { Banner } from '@marketplace-web/common-components/banner-ui'
import { BusinessAccountBannerModel } from '@marketplace-web/business-accounts/business-accounts-data'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import CancelRegistrationModal from './CancelRegistrationModal'

type Props = {
  banner: BusinessAccountBannerModel
}

const BusinessAccountBanner = ({ banner }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const breakpoints = useBreakpoint()

  const { title, body, continueButtonLabel, continueButtonUrl, cancelButtonLabel } = banner

  function handleCancelClick() {
    setIsModalOpen(true)
  }

  function handleModalClose() {
    setIsModalOpen(false)
  }

  return (
    <>
      <Banner
        isPhone={breakpoints.phones}
        title={<Text as="h1" text={title} type={Text.Type.Heading} />}
        body={<Text as="span" text={body} />}
        actions={[
          <Button
            text={continueButtonLabel}
            url={continueButtonUrl}
            styling={Button.Styling.Filled}
          />,
          <Button text={cancelButtonLabel} onClick={handleCancelClick} />,
        ]}
      />
      <CancelRegistrationModal isOpen={isModalOpen} onClose={handleModalClose} />
    </>
  )
}

export default BusinessAccountBanner
